import { render, staticRenderFns } from "./filtersBar.vue?vue&type=template&id=6ccbf8a3&scoped=true"
import script from "./filtersBar.vue?vue&type=script&lang=js"
export * from "./filtersBar.vue?vue&type=script&lang=js"
import style0 from "./filtersBar.vue?vue&type=style&index=0&id=6ccbf8a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccbf8a3",
  null
  
)

export default component.exports